import { apiSlice } from './apiSlice';
import { OPENINGSTORESTOCKS_URL } from '../constants';

export const openingStoreStocksApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ------------------------------------------------------------
    // CREATE OpeningStoreStock
    // ------------------------------------------------------------
    createOpeningStoreStock: builder.mutation({
      query: (openingStoreStock) => ({
        url: OPENINGSTORESTOCKS_URL,
        method: 'POST',
        body: openingStoreStock,
      }),
      invalidatesTags: ['OpeningStoreStocks'],
    }),

    // ------------------------------------------------------------
    // UPDATE OpeningStoreStock
    // ------------------------------------------------------------
    updateOpeningStoreStock: builder.mutation({
      query: ({ openingStoreStockId, ...data }) => ({
        url: `${OPENINGSTORESTOCKS_URL}/${openingStoreStockId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { openingStoreStockId }) => [
        { type: 'OpeningStoreStock', id: openingStoreStockId },
        'OpeningStoreStocks',
      ],
    }),

    // ------------------------------------------------------------
    // GET OpeningStoreStock Details
    // ------------------------------------------------------------
    getOpeningStoreStockDetails: builder.query({
      query: (openingStoreStockId) => ({
        url: `${OPENINGSTORESTOCKS_URL}/${openingStoreStockId}`,
      }),
      keepUnusedDataFor: 5,
      providesTags: (result, error, openingStoreStockId) => [
        { type: 'OpeningStoreStock', id: openingStoreStockId },
      ],
    }),

    // ------------------------------------------------------------
    // GET My OpeningStoreStocks
    // ------------------------------------------------------------
    getMyOpeningStoreStocks: builder.query({
      query: () => ({
        url: `${OPENINGSTORESTOCKS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['MyOpeningStoreStocks'],
    }),

    // ------------------------------------------------------------
    // GET All OpeningStoreStocks (Admin)
    // ------------------------------------------------------------
    getOpeningStoreStocks: builder.query({
      query: () => ({
        url: OPENINGSTORESTOCKS_URL,
      }),
      keepUnusedDataFor: 5,
      providesTags: ['OpeningStoreStocks'],
    }),

    // ------------------------------------------------------------
    // MARK OpeningStoreStock as Delivered (Admin)
    // ------------------------------------------------------------
    deliverOpeningStoreStock: builder.mutation({
      query: (openingStoreStockId) => ({
        url: `${OPENINGSTORESTOCKS_URL}/${openingStoreStockId}/deliver`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, openingStoreStockId) => [
        { type: 'OpeningStoreStock', id: openingStoreStockId },
        'OpeningStoreStocks',
      ],
    }),

    // ------------------------------------------------------------
    // DELETE OpeningStoreStock (Admin)
    // ------------------------------------------------------------
    deleteOpeningStoreStock: builder.mutation({
      query: (openingStoreStockId) => ({
        url: `${OPENINGSTORESTOCKS_URL}/${openingStoreStockId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, openingStoreStockId) => [
        { type: 'OpeningStoreStock', id: openingStoreStockId },
        'OpeningStoreStocks',
      ],
    }),
  }),
});

export const {
  useCreateOpeningStoreStockMutation,
  useUpdateOpeningStoreStockMutation,
  useGetOpeningStoreStockDetailsQuery,
  useGetMyOpeningStoreStocksQuery,
  useGetOpeningStoreStocksQuery,
  useDeliverOpeningStoreStockMutation,
  useDeleteOpeningStoreStockMutation,
} = openingStoreStocksApiSlice;
